import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { HttpService } from "./http.service";

const basePath = "/ImportationData";
const request = HttpService.handleRequest();

export const ImportationDataService = {
  getPaginatedList
};

async function getPaginatedList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

export default ImportationDataService;